module.exports = __webpack_public_path__ + "img/0-118.c17dab83.jpg";